import React, { createContext, useState } from "react"

const MyContext = createContext({
  isInquireOpen: false,
  updateInquireOpen: () => {},
  isSubscribeOpen: false,
  updateSubscribeOpen: () => {},
  context: "",
  updateContext: () => {},
  viewingRoom: false,
  updateViewingRoom: () => {},
  isEditions: false,
  updateIsEditions: () => {},
  editionArtist: "",
  updateEditionArtist: () => {},
  editionArtwork: "",
  updateEditionArtwork: () => {},
})

export const MyContextProvider = ({ children }) => {
  const [isInquireOpen, setInquireOpen] = useState(false)
  const [isSubscribeOpen, setSubscribeOpen] = useState(false)
  const [context, setContext] = useState("")
  const [viewingRoom, setViewingRoom] = useState(false)
  const [isEditions, setIsEditions] = useState(false)
  const [editionArtist, setEditionArtist] = useState("")
  const [editionArtwork, setEditionArtwork] = useState("")

  const updateInquireOpen = newValue => {
    setInquireOpen(newValue)
  }

  const updateSubscribeOpen = newValue => {
    setSubscribeOpen(newValue)
  }

  const updateContext = newValue => {
    setContext(newValue)
  }

  const updateViewingRoom = newValue => {
    setViewingRoom(newValue)
  }

  const updateIsEditions = newValue => {
    setIsEditions(newValue)
  }

  const updateEditionArtist = newValue => {
    setEditionArtist(newValue)
  }

  const updateEditionArtwork = newValue => {
    setEditionArtwork(newValue)
  }

  return (
    <MyContext.Provider
      value={{
        isInquireOpen,
        updateInquireOpen,
        isSubscribeOpen,
        updateSubscribeOpen,
        context,
        updateContext,
        viewingRoom,
        updateViewingRoom,
        isEditions,
        updateIsEditions,
        editionArtist,
        updateEditionArtist,
        editionArtwork,
        updateEditionArtwork,
      }}
    >
      {children}
    </MyContext.Provider>
  )
}

export default MyContext
